module.exports = __webpack_public_path__ + "static/media/ic_down_arrow_circle.b61cb6f9.png";